import { LmIconFilledAccountPeople, LmIconOutlineAccountPeople } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconSportClubsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineAccountPeople {...rest} /> : <LmIconFilledAccountPeople {...rest} />;

export default IconSportClubsCommon;
